export const loadFonts = {
  // Poppins
  'Poppins-Black': require('./Poppins/Poppins-Black.woff2'),
  'Poppins-Bold': require('./Poppins/Poppins-Bold.woff2'),
  'Poppins-ExtraBold': require('./Poppins/Poppins-ExtraBold.woff2'),
  'Poppins-ExtraLight': require('./Poppins/Poppins-ExtraLight.woff2'),
  'Poppins-Light': require('./Poppins/Poppins-Light.woff2'),
  'Poppins-Medium': require('./Poppins/Poppins-Medium.woff2'),
  'Poppins-Regular': require('./Poppins/Poppins-Regular.woff2'),
  'Poppins-SemiBold': require('./Poppins/Poppins-SemiBold.woff2'),
  'Poppins-Thin': require('./Poppins/Poppins-Thin.woff2'),
};
